import React from 'react';
import { useSlate } from 'slate-react';
import { ReactEditor } from 'slate-react';
import { IconButtonProps } from '@material-ui/core/IconButton';
import { isBlockActive, toggleBlock } from './helpers/utilities';
import ButtonBase from './ButtonBase';

interface Props extends IconButtonProps {
  format: string;
  Icon: React.ReactNode;
}

function BlockButton({ format, Icon, ...restOfProps }: Props) {
  const editor = useSlate() as ReactEditor;
  const isActive = isBlockActive(editor, format);
  const handleMouseDown = (e: any) => {
    e.preventDefault();
    toggleBlock(editor, format);
  };

  return (
    <ButtonBase onMouseDown={handleMouseDown} isActive={isActive} {...restOfProps}>
      {Icon}
    </ButtonBase>
  );
}

export default BlockButton;
